import { render, staticRenderFns } from "./dept-roles.vue?vue&type=template&id=c6204760&scoped=true"
import script from "./dept-roles.vue?vue&type=script&lang=js"
export * from "./dept-roles.vue?vue&type=script&lang=js"
import style0 from "./dept-roles.vue?vue&type=style&index=0&id=c6204760&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6204760",
  null
  
)

export default component.exports